var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4116 11.6252C13.5154 11.5561 13.6349 11.514 13.7591 11.5027C13.8834 11.4914 14.0085 11.5113 14.1231 11.5606L18.5444 13.5415C18.6934 13.6052 18.8177 13.7154 18.8989 13.8557C18.98 13.9959 19.0135 14.1587 18.9944 14.3196C18.8487 15.4081 18.3127 16.4066 17.486 17.1295C16.6593 17.8524 15.5982 18.2505 14.5 18.2496C11.1185 18.2496 7.87548 16.9063 5.48439 14.5152C3.0933 12.1241 1.75 8.88112 1.75 5.49961C1.74916 4.40143 2.1472 3.34032 2.87009 2.51361C3.59298 1.68691 4.59152 1.15089 5.68 1.00524C5.84091 0.986123 6.00368 1.01963 6.14395 1.10075C6.28422 1.18187 6.39444 1.30624 6.45813 1.45524L8.43906 5.88024C8.48774 5.99389 8.50756 6.11781 8.49676 6.24098C8.48596 6.36414 8.44489 6.48272 8.37719 6.58618L6.37375 8.96836C6.30269 9.0756 6.26066 9.19944 6.25179 9.32777C6.24291 9.45611 6.26749 9.58456 6.32313 9.70055C7.09844 11.2877 8.73906 12.9087 10.3309 13.6765C10.4475 13.7319 10.5766 13.7559 10.7053 13.7462C10.834 13.7365 10.958 13.6934 11.065 13.6212L13.4116 11.6252Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.7f663af23ee1dec0d234452673e2af9b.svg";
export { ForwardRef as ReactComponent };